import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/_services/profile.service';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { Response } from 'src/app/models/response';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { ModificaPasswordComponent } from './modifica-password/modifica-password.component';
import { MatDialog } from '@angular/material/dialog';
import { HobbyService } from 'src/app/_services/hobby.service';
import { UtilityService } from 'src/app/_services/utility.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-profilo-utente',
  templateUrl: './profilo-utente.component.html',
  styleUrls: ['./profilo-utente.component.css']
})
export class ProfiloUtenteComponent {
  panelOpenState = false;

  // profileData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  /*  teamembersData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    profilePic: string = '';
    imageChangedEvent: any = '';
    croppedImage: any = ''; */
  profileData: any;
  profile_hobby: any;
  argument_route: string;
  argument_route2: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly HobbyService: HobbyService,
    private readonly profileService: ProfileService,
    private readonly utilityService: UtilityService,
    private readonly title: Title,
    private readonly titleService: Title
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Profilo | Sviuppo Personale');
    this.utilityService.setTitle('Profilo utente');
    this.personalHobbies();
    this.getProfileData();
  }

  getProfileData() {
    this.profileService.getProfile().subscribe(res => {
      this.profileData = res.result;

      if (this.profileData.filestorage) {
        this.profileData.filestorage.path = this.utilityService.getSanitizeUrl(
          this.profileData.filestorage.path
        );
      }

      this.profileService.setImg(res.result);

      this.utilityService.setTitle(
        'Profilo utente | ' + res.result.first_name + ' ' + res.result.last_name
      );
      this.title.setTitle(
        'Profilo utente | ' + res.result.first_name + ' ' + res.result.last_name
      );
      // this.profile_hobby = res.data[1][0].hobby;
    });
  }

  personalHobbies() {
    this.HobbyService.personalHobbies().subscribe(res => {
      // this.profileData = res.data;
      this.profile_hobby = res.result;

      let utility = this.utilityService;

      this.profile_hobby.forEach(function (hobby: any) {
        hobby.hobbies.filestorage.path = utility.getSanitizeUrl(
          hobby.hobbies.filestorage.path
        );
        hobby.hobbies.children.forEach(function (child: any) {
          child.filestorage.path = utility.getSanitizeUrl(
            child.filestorage.path
          );
        });
      });
    });
  }
}
